import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import moment from "moment";
import { getCompanyCareerChanges } from "../../../services/address-book";

function CompanyCareerChanges({ companyId }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!companyId) return undefined;
    let cancelled = false;

    setLoading(true);
    setError(null);
    getCompanyCareerChanges(companyId, 10)
      .then((response) => {
        if (cancelled) return;
        setItems(response?.data?.items ?? []);
      })
      .catch((err) => {
        if (cancelled) return;
        const msg =
          err?.response?.data?.error?.message ??
          err?.message ??
          "Ismeretlen hiba";
        setError(msg);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [companyId]);

  return (
    <Box sx={{ mt: 2 }}>
      <h6 style={{ marginBottom: 4 }}>Utoljára lekérdezett linkek</h6>
      <Box
        sx={{
          maxHeight: 100,
          overflowY: "auto",
          border: "1px solid #eee",
          borderRadius: 1,
          padding: 1,
          fontSize: "0.875rem",
        }}
      >
        {loading && <span>Betöltés…</span>}
        {!loading && error && <span>Nem sikerült betölteni: {error}</span>}
        {!loading && !error && items.length === 0 && (
          <span>Nincs még link</span>
        )}
        {!loading &&
          !error &&
          items.map((item, i) => (
            <div key={`${item.date}-${item.url}-${i}`}>
              {moment(item.date).format("YYYY.MM.DD HH:mm")} -{" "}
              <a href={item.url} target="_blank" rel="noreferrer">
                {item.url}
              </a>
            </div>
          ))}
      </Box>
    </Box>
  );
}

CompanyCareerChanges.propTypes = {
  companyId: PropTypes.number.isRequired,
};

export default CompanyCareerChanges;
